<template>
  <sc-grid
    ref="gridLogsTrackingDetailEvent"
    :data="lote.eventsList"
    :total="lote.eventsList.length"
    :loading="loading"
    :has-style="false"
    default-sort-column="date"
    default-sort-direction="asc"
    :has-backend-pagination="true"
    :has-backend-sorting="false"
    @click="openEvent">

    <template
      slot="before-table">
      <div class="buttons">
        <sc-button
          theme="primary"
          :loading="loadingExporting"
          text="Exportar para o Excel"
          @click="exportLogsTrackingDetailEvent()"/>
      </div>
    </template>

    <template slot="table-columns" slot-scope="{ props }">
      <sc-table-column
        label="Date e hora"
        field="date"
        width="120">
        {{ props.row.date | date('DD/MM/YYYY HH:mm:ss') }}
      </sc-table-column>

      <sc-table-column
        label="Status"
        field="status"
        width="100">
        {{ props.row.status }}
      </sc-table-column>

      <sc-table-column
        label="Sub Status"
        field="substatus">
        {{ props.row.substatus }}
      </sc-table-column>

      <sc-table-column
        label="Mensagem"
        field="message"
        :centered="false">
        {{ props.row.message }}
      </sc-table-column>

      <sc-table-column
        label="Transportadora"
        field="logistic_provider">
        {{ getLogisticProviderName(props.row.logistic_provider_id) }}
      </sc-table-column>

      <sc-table-column
        label="Nota fiscal"
        field="invoice_number"
        width="150">
        {{ props.row.invoice_number }}
      </sc-table-column>

      <sc-table-column
        label="Pedido"
        field="shipment_order_number">
        {{props.row.shipment_order_number }}
      </sc-table-column>

      <sc-table-column
        label="Cod. original"
        field="original_code"
        width="90">
        {{ props.row.original_code }}
      </sc-table-column>

      <sc-table-column
        label="Cod. externo"
        field="external_code"
        width="90">
        {{ props.row.external_code }}
      </sc-table-column>
    </template>
  </sc-grid>
</template>

<script>
  import {
    ScGrid,
    ScTableColumn,
    ScTableEmpty,
    ScButton,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'tab-logs-tracking-lote-detail-event',
    computed: {
      ...mapState([
        'loading',
        'loadingExporting',
        'lote',
      ]),
    },
    methods: {
      ...mapActions([
        'exportAllLogs',
      ]),
      exportLogsTrackingDetailEvent() {
        const { config } = this.$refs.gridLogsTrackingDetailEvent || {};
        if (config) {
          this.exportAllLogs(Object.assign({}, config, {
            filters: Object.assign(config.filters, {
              hash: this.lote.hash,
            }),
          }));
        }
      },
      getLogisticProviderName(logisticProviderId) {
        return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
      },
      openEvent(row) {
        const { request_hash, original_code } = row;

        if (request_hash) {
          this.$router.push({
            name: 'logs-tracking-detail',
            params: {
              hash: request_hash,
              original_code,
            },
          });
        }
      },
      paginationEvents(config) {
        const {
          pagination,
        } = config;

        return this.$store.dispatch('logsTracking/getLote', pagination);
      },
    },
    beforeMount() {
      return this.$store.dispatch('logisticProviders/getLogisticProviders');
    },
    components: {
      ScGrid,
      ScTableColumn,
      ScTableEmpty,
      ScButton,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/tabs/tab-logs-tracking-lote-detail-event/TabLogsTrackingLoteDetailEvent.vue